document.addEventListener("DOMContentLoaded", () => {
  // Shopify Video Player Config
  const videoPlayers = document.querySelectorAll(
    ".js-video-player-remove-image"
  );

  if (videoPlayers.length > 0) {
    videoPlayers.forEach((videoPlayer) => {
      if (videoPlayer.hasAttribute("aria-label")) {
        videoPlayer.removeAttribute("aria-label");
      }

      videoPlayer.setAttribute("title", "Embedded Video Player");

      const img = videoPlayer.querySelector("img");
      if (img) {
        img.setAttribute("loading", "lazy");
        img.setAttribute("alt", "");
        img.setAttribute("aria-hidden", "true");
        img.setAttribute("role", "presentation");
      }
    });
  }

  // Gorgias Chat
  let chatButtonUpdated = false;
  let innerContainersUpdated = false;

  const intervalId = setInterval(() => {
    const gorgiasChatContainer = document.getElementById(
      "gorgias-chat-container"
    );

    if (!gorgiasChatContainer) return;

    if (!innerContainersUpdated) {
      gorgiasChatContainer.setAttribute("aria-hidden", "true");
      innerContainersUpdated = true;
    }

    const chatButton = gorgiasChatContainer.querySelector("#chat-button");
    if (chatButton && !chatButtonUpdated) {
      chatButton.removeAttribute("role");
      chatButtonUpdated = true;
    }

    if (chatButtonUpdated && innerContainersUpdated) {
      clearInterval(intervalId);
    }
  }, 100);

  // Klaviyo Email Marketing
  const popupIntervalId = setInterval(() => {
    const klaviyoPopup = document.querySelector(".kl-teaser-XHV8vb");

    if (klaviyoPopup) {
      klaviyoPopup.setAttribute("aria-hidden", "true");
      clearInterval(popupIntervalId);
    }
  }, 100);

  // Remove attributes from elements
  const removeAttributes = (selector, attributes, root = document, checkEmpty = false) => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= 200) {
        clearInterval(interval);
        return;
      }

      const elems = root.querySelectorAll(selector);
      if (elems.length === 0) return;

      let updated = false;

      elems.forEach((elem) => {
        const isTextEmpty = elem.textContent.trim().length === 0;

        if ((checkEmpty && isTextEmpty) || !checkEmpty) {
          attributes.forEach((attribute) => {

            if (elem.hasAttribute(attribute)) {
              elem.removeAttribute(attribute);
              updated = true;
            }
          });
        }
      });

      if (updated) clearInterval(interval);
    }, 100);
  };

  removeAttributes(".yotpo-review-title", ["role", "aria-level"], document, true);
  removeAttributes(".yotpo-reviews-pagination-item", ["href"]);
  removeAttributes(".eko-gallery", ["aria-controls"]);
  removeAttributes("a.rebuy-product-title, a.rebuy-cart__flyout-item-product-title", ["role", "aria-level"], document);

  const giftNoteCore = document.querySelector("giftnote-core");
  if (giftNoteCore?.shadowRoot) {
    removeAttributes("button.iti__selected-country", ["aria-controls"], giftNoteCore.shadowRoot);
    removeAttributes("#iti-0__dropdown-content .iti__search-input", ["aria-controls"], giftNoteCore.shadowRoot);
    removeAttributes("#method, #method li, #method button", ["role"], giftNoteCore.shadowRoot);
  }

  // Add attributes to elements
  const addAttributes = (selector, attributes, root = document) => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= 200) {
        clearInterval(interval);
        return;
      }

      const elems = root.querySelectorAll(selector);

      if (elems.length === 0) return;

      let updated = false;

      elems.forEach((elem) => {
        for (const [attr, value] of Object.entries(attributes)) {
          if (!elem.hasAttribute(attr)) {
            elem.setAttribute(attr, value);
            updated = true;
          }
        }
      });

      if (updated) clearInterval(interval);
    }, 100);
  };

  addAttributes(".eko-smart-gallery-container iframe", {
    "title": "Product Image Gallery",
    "aria-hidden": "true",
    "tabindex": "-1",
    "role": "presentation"
  });

  addAttributes(".eko-gallery", {"aria-hidden": "true"});
  addAttributes("giftnote-core", { "aria-hidden": "true" });
  addAttributes("#li_sync_frame", {"title": "Sync Container"});

  addAttributes(
    ".yotpo-star-rating-icon, .yotpo-verified-icon, .yotpo-reviews-pagination-item svg",
    {
      "aria-hidden": "true",
      role: "presentation",
      focusable: "false",
    }
  );

  const shopifyPaymentTerms = document.querySelector("shopify-payment-terms");
  if (shopifyPaymentTerms?.shadowRoot) {
    addAttributes("#shopify-installments-content svg",
      {
        "aria-hidden": "true",
        role: "presentation",
        focusable: "false"
      }, shopifyPaymentTerms.shadowRoot);
  }

  // Set attributes on elements
  const setAttributes = (selector, attributes, root = document, checkEmpty = false) => {
    let attempts = 0;
    const interval = setInterval(() => {
      if (attempts++ >= 200) {
        clearInterval(interval);
        return;
      }

      const elems = root.querySelectorAll(selector);
      if (elems.length === 0) return;

      let updated = false;

      elems.forEach((elem) => {
        const isTextEmpty = elem.textContent.trim().length === 0;

        if ((checkEmpty && isTextEmpty) || !checkEmpty) {
          for (const [attribute, value] of Object.entries(attributes)) {
            if (elem.getAttribute(attribute) !== value) {
              elem.setAttribute(attribute, value);
              updated = true;
            }
          }
        }
      });

      if (updated) clearInterval(interval);
    }, 100);
  };

  setAttributes('.rebuy-product-grid .rebuy-product-image img', { 'loading': 'lazy', 'alt': '', 'aria-hidden': 'true' });

  const setRebuyImageAriaLabel = () => {
    const updateAriaLabels = () => {
      const imageWrappers = document.querySelectorAll(
        ".rebuy-product-grid .rebuy-product-image"
      );
      if (imageWrappers.length === 0) return false;

      let updated = false;

      imageWrappers.forEach((imageWrapper) => {
        imageWrapper.querySelectorAll("img").forEach((img) => {
          img.setAttribute("alt", "");
        });

        const mediaParent = imageWrapper.closest(".rebuy-product-block");
        if (!mediaParent) return;

        const infoSibling = mediaParent.querySelector(".rebuy-product-info a");
        if (!infoSibling) return;

        const label = infoSibling.getAttribute("aria-label");
        if (label && imageWrapper.getAttribute("aria-label") !== label) {
          imageWrapper.setAttribute("aria-label", label);
          updated = true;
        }
      });

      return updated;
    };

    let attempts = 0;
    const maxAttempts = 200;
    const intervalTime = 100;

    const interval = setInterval(() => {
      if (attempts++ >= maxAttempts) {
        clearInterval(interval);
        return;
      }

      const grid = document.querySelector(".rebuy-product-grid");

      if (!grid) return;

      const updated = updateAriaLabels();

      const observer = new MutationObserver(updateAriaLabels);
      observer.observe(grid, {
        childList: true,
        subtree: true,
      });

      clearInterval(interval);
    }, 100);
  };

  setRebuyImageAriaLabel();
});
